import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Simple component to render an asterisk if the prop is true
 * @param {*} isRequired boolean to indicate if the field is required
 * @returns
 */
import { jsx as _jsx } from "react/jsx-runtime";
const RequiredIndicator = _ref => {
  let {
    isRequired
  } = _ref;
  if (isRequired) {
    return /*#__PURE__*/_jsx(Box, {
      component: "span",
      sx: {
        color: 'red'
      },
      children: "*"
    });
  }
  return null;
};
RequiredIndicator.propTypes = {
  isRequired: PropTypes.bool
};
RequiredIndicator.defaultProps = {
  isRequired: true
};
export default RequiredIndicator;